module.exports = __webpack_public_path__ + "static/media/nav-patients.a85d4dfd.svg";